import { render, staticRenderFns } from "./sendMakeDoc.vue?vue&type=template&id=78fd82b7&"
import script from "./sendMakeDoc.vue?vue&type=script&lang=js&"
export * from "./sendMakeDoc.vue?vue&type=script&lang=js&"
import style0 from "./sendMakeDoc.vue?vue&type=style&index=0&id=78fd82b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports